import { trpc } from "@blis/trpc/react";

import { AuthProvidersTable } from "../components/auth/AuthProvidersTable";
import { Section } from "../components/Section";

export function AuthPage() {
  const { data } = trpc.admin.auth.list.useQuery();

  return (
    <>
      <Section.Title>Authentication</Section.Title>
      <AuthProvidersTable providers={data} />
    </>
  );
}
